import styled from 'styled-components'
import media from 'styled-media-query'

export const BoxesContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: ${props => props.mode === 'grid' ? 'center' : 'flex-start'};
`

export const Container = styled.div`
  display: flex;
  min-height: 45px;
  flex-direction: row;
  ${media.lessThan('1035px')`
  flex-direction: column;
  `}
  `
